import { render, staticRenderFns } from "./transferPage.vue?vue&type=template&id=dc07f9ce&scoped=true"
import script from "./transferPage.vue?vue&type=script&lang=js"
export * from "./transferPage.vue?vue&type=script&lang=js"
import style0 from "./transferPage.vue?vue&type=style&index=0&id=dc07f9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc07f9ce",
  null
  
)

export default component.exports